export default __webpack_public_path__ + "static/media/internet-plan-hover.059e64d8.svg";